import axios from "axios";
import config from "./config";

/**
 * Native membership login.
 *
 * Replaces the old community-login adapter: posts to the production
 * `api/login` (AuthController -> Tymon JWT over membership_user) with
 * { email, password, funnel_id }. funnel_id is the community's id
 * (community.community_id, returned by membership-groups).
 *
 * The returned JWT is stored as the member's auth_token / member_token and
 * replayed on every community-* call — the bridge's authMember now verifies
 * this native JWT (body member_token OR Authorization: Bearer), so one login
 * token works across the whole app.
 *
 * Returns the member object the FE persists, or throws (message on the error).
 */
export async function nativeLogin({ funnelId, email, password }) {
  const res = await axios.post(`${config.API_URL}/login`, {
    funnel_id: funnelId,
    email,
    password,
  });

  const token = res.data?.access_token;
  const mu = res.data?.MembershipUser || {};
  if (!token || mu.id == null) {
    throw new Error(res.data?.message || "Invalid email or password.");
  }

  return {
    community_member_id: mu.id,
    // funnel_id = the community id; the native learning API (courselist/lessonlist)
    // is funnel-scoped, so every component reads it off the member.
    funnel_id: funnelId,
    name: mu.name || "",
    email: mu.email || email,
    img: mu.profile_img || null,
    points: mu.tot_points || 0,
    url_token: String(mu.id),
    // The JWT — replayed to community-* (member_token) and native (Bearer) calls.
    auth_token: token,
    member_token: token,
  };
}
